import React from 'react';
import './index.scss';
import {toJS} from 'mobx';


import { inject, observer } from 'mobx-react';

import {api} from '../../../../functions/api'

import Icon from '@mdi/react'
import {mdiPlus} from '@mdi/js'

import CircularProgress from '@material-ui/core/CircularProgress';

import CustomTable from '../../../../components/complex/customTable'
import CustomButton from '../../../../components/basic/CustomButton'
import CustomSnackbar from '../../../../components/global/snackbar'
import DeleteDialog from '../../../../components/global/deleteDialog'
import CustomSelect from '../../../../components/basic/CustomSelect'
import UploadDocument from './add';
import queryString from 'query-string'

const TIMEOUT = 3000;

@inject('translate')
@inject('internal')
@observer
export default class ClientDocs extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            openSnackbar: false,
            message: "",
            openUploadDialog: false,
            document_type_id: null
        }
    }

    componentDidMount() {
        this.loadClientDocs();
        //this.props.internal.setRoute( this.props.history, this.props.location.pathname)
        this.props.internal.setRoute( this.props.routerData.history, this.props.routerData.location.pathname)

        const URLqueryString = this.props.routerData.history.location.search
        let queries = queryString.parse(URLqueryString)

        let document_type_id;
        if(queries.document_type_id) {
            document_type_id = queries.document_type_id;
            this.setState({document_type_id: document_type_id},() => {
            })
        }
    }

    timeout = null;
    componentWillUnmount() {
        clearTimeout(this.timeout)
    }

    turnOffSnackBar = () => {
        clearTimeout(this.timeout)
        this.timeout =  setTimeout(() => {
            this.setState({message: "", openSnackbar: false})
        }, TIMEOUT)
    }

    setPermissions() {
        let permissions = toJS(this.props.internal.user.data.permissions.clients_documents)

        this.dropDownMenuItems = []
        this.dropDownMenuItems.push(
            {
                title: this.props.translate.i18n.GLOBAL.BUTTONS.DOWNLOAD,
                action: "download"
            },
        )

        if(permissions.destroy) {
            this.dropDownMenuItems.push(
                {
                    title: this.props.translate.i18n.GLOBAL.BUTTONS.DELETE,
                    action: "delete"
                }
            )
        }
    }

    dropDownMenuItems = [
        // {
        //     title: this.props.translate.i18n.GLOBAL.BUTTONS.DOWNLOAD,
        //     // url: "edit/tab=0"
        //     //url: "detail/tab=0"
        //     action: "download"
        // },
        // {
        //     title: this.props.translate.i18n.GLOBAL.BUTTONS.DELETE,
        //     //url: "delete",
        //     action: "delete"
        // }
    ]

    tableHeader = [
        {"title":"document_type", "numeric":false},
        {"title":"title", "numeric":false},
        {"title":"date", "numeric":false},
        {"title":"uploaded_by", "numeric":false},
        {"title":"extension", "numeric":false}
    ];
    tableBody = ["document_type", "name", "updated_at", "creator", "extension"]

    loadClientDocs = async (size = 100, page = 0, searchterm = "", by = "name", dir = "asc") => {
        this.setState({loading: true})
        const URLqueryString = this.props.routerData.history.location.search
        let queries = queryString.parse(URLqueryString);

        let document_type_id = null;
        if(queries) {
            
            if(queries.document_type_id) {
                document_type_id = queries.document_type_id
            }
        }


        let params = {
            searchterm: searchterm,
            page:{
                number:page,
                size:size,
            },
            order: [
                {
                    by: by,
                    dir: dir
                }
            ]
        }

        let filters = {}
        if(document_type_id !== null) {
           
            filters.document_type_id = Number(document_type_id)
            params.filters = filters
            
        }

        let idClient = toJS(this.props.routerData.match.params.idClient)
        let load_data = await api({
            method:'get',
            url:'clients/'+idClient+"/documents",
            authorization: this.props.internal.user.access_token,
            params:params
        })

        if(load_data.success === true) {
            if(load_data.data) {
                let tmpData = load_data.data.data;
                for(let i=0; i<tmpData.length; i++) {
                    for(let prop in tmpData[i]) {
                        if(prop === "name") {
                            let extension = tmpData[i][prop].split(".")
                            extension = extension[extension.length - 1]
                            tmpData[i]['extension'] = extension
                        }
                        else if(prop === "document_type") {
                            let type = tmpData[i][prop]["name"];
                            tmpData[i]["document_type"] = type
                        }
                        else if(prop === "creator") {
                            let username = tmpData[i][prop]["username"];
                            tmpData[i]["creator"] = username
                        }
                    }
                    
                }
                load_data.data.data = tmpData
                
                this.props.internal.setDataForTable(load_data.data)
                this.setPermissions();
            }
        }
        this.setState({loading: false})
    }

    handleChangeRowsPerPage = (size) => {
        this.setState({loading: true});
        this.loadClientDocs(size, 1)
    }

    handleChangePage = (page) => {
        this.setState({loading: true});
        let tmpSize = Number(toJS(this.props.internal.dataForTable.meta.per_page));
     
        this.loadClientDocs(tmpSize, page+1)
    }

    handleSort = (dir, orderBy) => {
        let tmpSize = Number(toJS(this.props.internal.dataForTable.meta.per_page));
        let tmpPage = Number(toJS(this.props.internal.dataForTable.meta.current_page))
        this.loadClientDocs(tmpSize, tmpPage, "", orderBy, dir)
    }

    handleDeleteDoc = () => {
        this.props.internal.setActionDelete();
        this.deleteDoc(this.props.internal.actionDeleteObj.id)
    }

    deleteDoc = async() => {
        let idClient = Number(toJS(this.props.routerData.match.params.idClient));
        let idDocument = Number(toJS(this.props.internal.actionDeleteObj.id));

        let delete_data = await api({
            method:'delete',
            url:'clients/'+idClient+"/documents/"+idDocument,
            authorization: this.props.internal.user.access_token,
        })

        if(delete_data.success === true) {
            // this.setState({message: delete_data.data.message, openSnackbar: true})
            this.props.internal.setSnackbar(delete_data.data.message, true)
            this.loadClientDocs();
        }
        else {
            // this.setState({message: delete_data.data.message, openSnackbar: true})
            this.props.internal.setSnackbar(delete_data.data.message, true)
        }

        this.turnOffSnackBar();
    }

    filterTable = data => {
        //this.loadClientDocs(100, 0, data.toLowerCase())
        this.addQueryToUrl("document_type_id", data)
    }

    addQueryToUrl = (param, value, param2 = null, value2 = null) => {
        const URLqueryString = this.props.routerData.history.location.search
        let queries = queryString.parse(URLqueryString)
        queries[param] = value
        if(param2 && value2) {
            queries[param2] = value2
        }

        let new_path = this.props.routerData.location.pathname

        new_path += "?"
        for(let key in queries) {
            if(key) {
                new_path += key + "=" + queries[key] + "&"
            }
        }
        new_path = new_path.slice(0,-1)

        this.props.internal.pushRoute(new_path)
        this.loadClientDocs()
        this.setState({document_type_id: value})
    }

    handleClickOpenDialog = () => {
        this.refs.fileUploader.click();
    }

    handleClickOpenUploadDialog = () => {
        this.setState({openUploadDialog: true})
    }

    handleClickCloseUploadDialog = () => {
        this.setState({openUploadDialog: false})
    }

    showSnackbar = (message, open, dialog) => {
        this.setState({message: message, openSnackbar: open})
        this.turnOffSnackBar()
        if(!dialog) {
            this.setState({openUploadDialog: dialog})
            this.loadClientDocs()
        }
    }

    render() {
        let permissions;
        if(!this.state.loading) {
            permissions = toJS(this.props.internal.user.data.permissions.clients_documents)
        }
        return (
            <div className={'client-docs-container'}>
                <CustomSnackbar message={this.state.message} open={this.state.openSnackbar} />
                {this.state.openUploadDialog ?
                    <UploadDocument
                        open={this.state.openUploadDialog}
                        onClose={this.handleClickCloseUploadDialog}
                        title={this.props.translate.i18n.MODULES.CLIENTS.CREATE_NEW_USER_DIALOG_TITLE}
                        routerData={this.props.routerData}
                        showSnackbar={this.showSnackbar}
                    />
                    :
                    null
                }
                
                <DeleteDialog
                    open={this.props.internal.actionDelete}
                    title={this.props.translate.i18n.MODULES.CLIENTS.DELETE_DOCUMENT_TITLE}
                    content={this.props.translate.i18n.GLOBAL.ALERTS.DELETE_ITEM}
                    btn_cancel={this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                    btn_delete={this.props.translate.i18n.GLOBAL.BUTTONS.DELETE}
                    delete={this.handleDeleteDoc}
                />
                {this.state.loading ?
                    <CircularProgress className={'circular-progress'} />
                    :
                    <div className={'first-line'}>
                        <div className={'flex space-between'}>
                            <CustomSelect
                                title={this.props.translate.i18n.MODULES.CLIENTS.CHOOSE_DOC_TYPE}
                                data={toJS(this.props.internal.dataForTable.lists.document_types)}
                                filter={this.filterTable}
                                selected={this.state.document_type_id}
                            />
                            {/* <Search placeholder={this.props.translate.i18n.MODULES.CLIENTS.SEARCH} classes={'client-search'} onChange={this.handleSearch}/> */}
                            {permissions.store
                                ?
                                <div>
                                    <CustomButton
                                        mystyle={'btn-orange-bg border-radius-18'}
                                        title={this.props.translate.i18n.GLOBAL.BUTTONS.UPLOAD}
                                        onClick={this.handleClickOpenUploadDialog}
                                    >
                                        <Icon path={mdiPlus} size={1}  />
                                        
                                    </CustomButton>
                                </div>
                                
                                :
                                null
                            }
                            
                        </div>
                
                        <CustomTable
                            dropDownMenuItems={this.dropDownMenuItems}
                            module={'/clients'}
                            handleChangeRowsPerPage={this.handleChangeRowsPerPage}
                            handleChangePage={this.handleChangePage}
                            handleSort={this.handleSort}
                            header={this.tableHeader}
                            body={this.tableBody}
                            disableSort
                        />
                    </div>
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/clients/detail/docs/index.js